import React from 'react';
import { css } from '@emotion/react';
import DropdownMenu from '../../primitives/dropdown-menu';
import ColSet from '../../primitives/grid/col-set';
import Typography from '../../primitives/typography';
import Skeleton from '../../primitives/skeleton';
import formatPhoneLink from '../../utils/format-phone-link';
import ArrowDropdown from '../../../images/svg/arrow-header-dropdown.svg';
import HeaderDropdown from './header-dropdown';
import StyledPhoneNumber from './styled-phone-number';

export interface DropdownMenuProps {
    text: string
    phoneNumber?: string
    phoneDisplay?: string
}

const styles = {
    colSet: css({
        display: 'flex',
        position: 'relative',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 'auto',
    }),
    typography: css({
        textAlign: 'right',
        span: {
            lineHeight: 1.1,
        },
    }),
    arrow: css({
        transition: '0.2s',
        '[data-state="open"] &': {
            transform: 'rotate(180deg)',
        },
    }),
};

const StyledDropdown = ({
    text,
    phoneNumber,
    phoneDisplay,
}: DropdownMenuProps): JSX.Element => (
    <DropdownMenu
        align="end"
        title={(
            <ColSet
                breakpoints={{
                    dt: { between: 10 },
                }}
                css={styles.colSet}
            >
                <Typography
                    fontSize="sm"
                    css={styles.typography}
                >
                    <span>{text}</span>
                    <Skeleton>
                        {phoneNumber && (
                            <StyledPhoneNumber
                                href={`tel:${phoneNumber}`}
                            >
                                {formatPhoneLink(phoneNumber || phoneDisplay)}
                            </StyledPhoneNumber>
                        )}
                    </Skeleton>
                </Typography>
                <ArrowDropdown
                    css={styles.arrow}
                />
            </ColSet>
        )}
    >
        <HeaderDropdown />
    </DropdownMenu>
);

export default StyledDropdown;
